import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const emailToShipperRenderer = ({
  changes: { notification_time, start_time, end_time },
  ...props
}) => {
  return (
    <Spacer {...props}>
      {!!notification_time && !!start_time && !!end_time && (
        <Text color="grey800" display="block">
          Shipper notified at {notification_time} that driver will arrive between {start_time} and{' '}
          {end_time}
        </Text>
      )}
    </Spacer>
  );
};

export default emailToShipperRenderer;
